import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, } from 'rxjs/operators';
import {  GetLovBO } from './lov.model';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
  
import { GlobalComponent } from 'src/app/global/global.component';
@Injectable({
  providedIn: 'root'
})
export class LovDateService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public execute(Lovstate: GetLovBO): void {
    this.getLov(Lovstate).subscribe(x => super.next(x));
  }
 
  getLov(Lovstate?: GetLovBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/LOV/GetLovs?", Lovstate)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
     //==============================get employee permission==========================================//
     getpermission(paramsData: URLSearchParams): Observable<any> {
      let url = "api/FunctionPermission/getfunctionpermissionemployee?";
      return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
        map(data => data.body),
        catchError(this.errorService.handleError)
      )
    }
}
